import styled from 'styled-components';

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: 300px;
`;

export const ProductContainerRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: ${props => props.cursor ?? ''};
`;

export const ProductOptionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: right;
    align-items: center;
    width: 95%;
    margin-top: 20px;
`;

export const ProductDataContainer = styled.div`
    text-align: left;
    max-width: 40vw;
`;

export const ProductDataTitle = styled.h4`
  
`;

export const ProductDataText = styled.p`
    margin-left: 5px;
`;